export default "__VITE_ASSET__DKXVW6Px__"